import { render, staticRenderFns } from "./p-lookup.vue?vue&type=template&id=fe72ab40&"
import script from "./p-lookup.vue?vue&type=script&lang=js&"
export * from "./p-lookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports